/* unplugin-vue-components disabled */import { render } from "./PrivacyPolicy.vue?vue&type=template&id=6435a6ac&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=6435a6ac&scoped=true&lang=css"

import exportComponent from "/data/git/eshopweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6435a6ac"]])

export default __exports__